__turbopack_context__.v({
  "verified": "icons-module__aMKg7a__verified",
});
